<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Banco</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroBanco" ref="formCadastroBanco" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2" sm="3">
                            <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                        </v-col>
                        <v-col cols="12" md="7" sm="6">
                            <v-text-field v-model="item.nome" label="Descrição" :rules="fieldRules" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3" sm="3">
                            <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="1" sm="2">
                            <v-text-field v-model="item.agencia" label="Agência" :counter="10" maxlength="10" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="5" sm="5">
                            <v-text-field v-model="item.contaCorrente" label="Conta Corrente" :counter="10" maxlength="10" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" sm="5">
                            <v-text-field v-model="item.numeroContrato" label="Número Contrato" :counter="25" maxlength="25" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2" sm="3">
                            <v-text-field v-model="item.cep" label="CEP" v-mask="mskCep" @change="ObterEndereco(item.cep)" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3" sm="5">
                            <v-text-field v-model="item.logradouro" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2" sm="4">
                            <v-text-field v-model="item.bairro" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-text-field v-model="item.cidade" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2" sm="6">
                            <v-select v-model="item.uf" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2" sm="4">
                            <v-select v-model="item.carteira" label="Carteira" :items="carteiras" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4" sm="4">
                            <v-text-field v-model="item.gerente" label="Gerente" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3" sm="4">
                            <v-text-field v-model="item.gerenteTelefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3" sm="4">
                            <v-text-field v-model="item.gerenteCelular" label="Celular" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4" sm="4">
                            <v-text-field v-model="item.gerenteEmail" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" sm="4">
                            <v-autocomplete v-model="item.planoContaContabilId" :items="planoContas" label="Plano Conta Contábil" item-value="id" item-text="codigoNome" clearable dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2" sm="4">
                            <v-select v-model="item.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import BancoService from '@/core/services/financeiro/BancoService';
import BancoEnumService from '@/core/services/financeiro/BancoEnumService';
import CarteiraService from '@/core/services/financeiro/CarteiraService';
import {EstadoEnumService, SituacaoEnumService, EnderecoService } from '@/core/services/geral';
import Banco from '@/core/domain/financeiro/Banco';
import PlanoContaContabilService from '../../../core/services/financeiro/PlanoContaContabilService';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        'item.bancoId': {
            handler: function (val) {

                let carteiraService = new CarteiraService();
                carteiraService.Listar(val)
                    .then(
                        res => {
                            this.carteiras = res.data;
                        },
                        err => {
                            this.$swal('Aviso', err.message, 'error')}
                    )

            },
            deep: true
        },
        item: function() { 
            if ('formCadastroBanco' in this.$refs)
                this.$refs.formCadastroBanco.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new BancoService(),
        mskTelefone: process.env.VUE_APP_MSK_TELEFONE,
        mskCep: process.env.VUE_APP_MSK_CEP,
        valid: true,
        dialog: false,
        isLoading: false,
        bancos: [],
        estados: [],
        situacoes: [],
        carteiras: [],
        planoContas: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroBanco.validate()) {

                this.salvando = true;

                let modelo = new Banco(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
        },
        ObterEndereco(cep){
            let enderecoService = new EnderecoService();
            enderecoService.ObterPorCep(cep)
            .then(
                res => {
                    let endereco = res.data;
                    if (endereco) {
                        this.item.logradouro = endereco.logradouro;
                        this.item.bairro = endereco.bairro;
                        this.item.cidade = endereco.municipio;
                        this.item.uf = endereco.estado;
                        this.item.pais = endereco.pais;
                    }
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        let bancoEnumService = new BancoEnumService();
        bancoEnumService.Listar()
            .then(
                res => {
                    this.bancos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            )


        let estadoEnumService = new EstadoEnumService();
        estadoEnumService.Listar()
            .then(
                res => {
                    this.estados = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            )

        let situacaoEnumService = new SituacaoEnumService();
        situacaoEnumService.Listar()
            .then(
                res => {
                    this.situacoes = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            )
        let planoContaContabilService = new PlanoContaContabilService();
        planoContaContabilService.ListarTudo().then(
            res => {
                this.planoContas = res.data.items.filter(x => x.tipoConta === 'A');
            }
        )
    }
}
</script>
